// FormSubmission.js   a vue composable for various form submission in Nas Biz Advisory website

import { collection, doc, setDoc} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { client_id, client_name, client_emails } from "../../config_nas"
import { fb_firestoreDB, fb_funcs } from "@/main"

export async function submitContactForm(data_dict) {
  const email_re_pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/ // Email address pattern
  // console.log(data_dict)
  const publish_contact = httpsCallable(fb_funcs, "publish_contact")
  const send_WelcomeEmail = httpsCallable(fb_funcs, "sendWelcomeEmail")
  const submission_data = {
    c_email: null,
    c_full_name: null,
    c_contact_number: null,
    c_preferred_call_time: null,
    c_notes: null,
    rcd_id: null,
    creation_datetime: null,
    read_status: null,
  }
  // client specific data attr
  Object.assign(submission_data, data_dict)
  // form completeness validation is done in the context before invoking this function.
  // email regex validation
  if(!email_re_pattern.test(data_dict.c_email)) {
    // invalid email format. null also trigger regex test false
    alert(`Invalid Email address ${data_dict.c_email}. Please review and try again.`)
    return
  }
  // -----------------------
  try {
    // get doc id
    const new_doc_ref = doc(collection(fb_firestoreDB, "contact"))
    const contact_id = new_doc_ref.id
    // standard data attr
    submission_data["rcd_id"] = contact_id
    submission_data["creation_datetime"] = new Date().getTime()
    submission_data["read_status"] = "unread"
    // upload
    await setDoc(new_doc_ref, submission_data)
      .then(res => {
        // console.log("Contact has been saved!")
      })
      .then(async () => {
        // console.log("Continue with contact update!")
        // carry on cloud function for publishing form to Pub/Sub that will forward the form in an email.
        let msg_object = {}
        // --------- add standard system fields ---------------
        msg_object['client_id'] = client_id
        msg_object['client_name'] = client_name
        msg_object['client_emails'] = client_emails
        // --------- standardize field names ---------------
        msg_object["rcd_id"] = { field_name: "Record ID", field_value: submission_data["rcd_id"] }
        msg_object["creation_datetime"] = { field_name: "Created Time", field_value: submission_data["creation_datetime"] }
        msg_object["read_status"] = { field_name: "Read Status", field_value: "unread" }
        // --------- customized fields ---------------
        msg_object['c_full_name'] = { field_name: "Full Name", field_value: submission_data['c_full_name'] }
        msg_object['c_email'] = { field_name: "Email", field_value: submission_data['c_email'] }
        msg_object['c_contact_number'] = { field_name: "Contact Number", field_value: submission_data['c_contact_number'] }
        msg_object['c_preferred_call_time'] = { field_name: "Preferred Call Time", field_value: submission_data['c_preferred_call_time'] }
        msg_object['c_notes'] = { field_name: "Notes", field_value: submission_data['c_notes'] }
        // ----------------------------------------------------
        await publish_contact({ submission_data: msg_object })
          .then((res) => {
            const errMsg = res.data.errMsg
            if (errMsg) {
              throw new Error(errMsg)
            } else {
              alert("Thank you for registering your interest! We will reach out to you shortly.")
              // console.log("Message published to pubsub")
            }
          })
        // send welcome email
        // email integration with send grid
        // Welcome email template is built in server side code to prevent exploitation (copy form Nas existing version.)
        await send_WelcomeEmail({c_email: submission_data['c_email'], c_notes: submission_data['c_notes']})
          .then((res) => {
            const errMsg = res.data.errMsg
            if (errMsg) {
              throw new Error(errMsg)
            } else {
              // console.log("Welcome email has been sent")
            }
          })
        // download file (optional) - not required for now.
        // if(data_dict?.c_file_url){
        //   // 
        // }
      })
  } catch (e) {
    // console.log("submission_data:", submission_data)
    console.error(e.message)
    console.error(e)
    alert("Someting went wrong!")
  }
  // expose managed state as return value
  // return { x, y }
}